import { render, staticRenderFns } from "./run-gallery.vue?vue&type=template&id=09145013&scoped=true&"
import script from "./run-gallery.vue?vue&type=script&lang=ts&"
export * from "./run-gallery.vue?vue&type=script&lang=ts&"
import style0 from "./run-gallery.vue?vue&type=style&index=0&id=09145013&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09145013",
  null
  
)

export default component.exports